<script setup lang="ts">
import { useToast } from '@/utils/toast'
import Toast from './toast.vue'

const { toasts, removeToast } = useToast()
</script>

<template>
  <div>
    <Toast
      v-for="toast in toasts"
      :key="toast.id"
      :message="toast.message"
      :type="toast.type"
      :duration="toast.duration"
      :is-visible="toast.isVisible"
      :buttons="toast.buttons"
      :show-close="toast.showClose"
      :icon="toast.icon"
      @close="removeToast(toast.id)"
    />
  </div>
</template>
